module.exports = __webpack_public_path__ + "img/btn1.1a36281a.png";